import React, {useState, useEffect, useRef} from 'react'

// Deps
//import animateScrollTo from 'animated-scroll-to';
import parse from 'html-react-parser'

// Partials
import Loader from 'views/shared/partials/loader'

const Tabs = (props) => {
	const childrenProps = props.children;
	const containerRef = useRef(null);

	const [children, setChildren] = useState([])

	const [activeTab, setActiveTab] = useState(false);

	const changeTab = (tab, scroll = false) => {
		setActiveTab(tab);

		// if (scroll && window.isMobile) {
		// 	animateScrollTo(containerRef.current);
		// }

		children.forEach((childTab, index) => {
			if(childTab.props.index === tab && childTab.props.onChange) {
				childTab.props.onChange(tab);
			}
		});

		if(props.onChange){
			props.onChange(tab);
		}

	}

	useEffect(() => {
		let activeIndex = 0;
		
		let childrenCache = React.Children.toArray(childrenProps);

		if(childrenCache[0] && childrenCache[0].type === React.Fragment) {
			childrenCache = React.Children.toArray(childrenCache[0].props.children);
		}
		childrenCache.forEach((tab, index) => {
			if (tab.props.active) {
				activeIndex = index;
			}
		});
		setChildren(childrenCache);

		if(activeIndex > 0 || !activeTab) {
			setActiveTab(childrenCache.length ? childrenCache[activeIndex].props.index : false)
		}

	}, [childrenProps, activeTab]);

	return (
		<section className={props.className + ' tabs-container loader-container'} ref={containerRef}>
			<Loader loading={!(children && children.length)} />
			<div className={"tabs-labels" + (props.narrow ? ' narrow' : '')/*+ (children.length < 5 ? ' narrow' : '')*/}>
				<div className="labels-innerwrap">
					{children.map((child, nth) => {
						const { index, className } = child.props
						let label = parse(child.props.label.split('\\n').join('<br />'));

						return (
							<div key={index} className="labels-item">
								<button
									className={'item-btn ' + (className || '') + (index === activeTab ? ' active' : '')}
									onClick={() => {
										changeTab(index)
									}}
								>
									{child.props.icon &&
										<i className={'btn-icon icon-' + child.props.icon}></i>
									}
									{label}
									{(child.props.badge !== undefined) &&
										<span className={'btn-badge ' + (child.props.badgeClass ? child.props.badgeClass : '')}>{child.props.badge}</span>
									}
								</button>
							</div>
						)
					})}
				</div>
			</div>
			<div className="tabs-items">
				{children.map(child => {
					// const { index, children, className } = child.props
					return (
						<Tab
							className={child.props.className || ''}
							key={child.props.index}
							alwaysRender={props.alwaysRender}
							active={child.props.index === activeTab}>
							{child.props.children}
						</Tab>
					)
				})}
			</div>
		</section>
	)
}

const Tab = (props) => {

	const [active, setActive] = useState(props.active);
	const [show, setShow] = useState(props.active);

	useEffect(() => {
		if (props.active) {
			setTimeout(() => {
				setActive(true);
				setTimeout(() => {
					setShow(true);
				}, 50)
			}, 350)
		} else {
			setShow(false);
			setTimeout(() => {
				setActive(false);
			}, 350)
		}
	}, [props.active]);

	if (active || props.alwaysRender) {
		return (
			<div className={'items-tab' + (active ? ' active' : '') + (show ? ' show ' : '')}>
				{props.children}
			</div>
		)
	}
	else { return false }
}

Tabs.defaultProps = {
	className: '',
	title: false,
	alwaysRender: false,
}

export default Tabs;